<h1 class="h5 mb-0">Pixels/postbacks</h1>
<p class="text-muted">Manage third-party conversion tracking pixels and postback URLs.</p>

<div class="card shadow border-0">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover table-striped">
        <thead class="table-light">
          <tr>
            <th>Goal</th>
            <th>Type</th>
            <th>Offer</th>
            <th>Code/URL</th>
            <th>Added</th>
            <th>Last Modified</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (postback of postbacks; track postback) {
            <tr>
              <td class="align-middle">{{ postback.goal }}</td>
              <td class="align-middle">Postback</td>
              <td class="align-middle">
                @for (offer of postback.offers; track offer) {
                  <span class="me-2">
                    <a [routerLink]="['/offer', offer.id]" class="text-decoration-none">{{ offer }}</a>
                    <a [routerLink]="['/offer', offer.id]" class="ms-1"><i class="bi bi-box-arrow-up-right"></i></a>
                  </span>
                }
              </td>
              <td class="align-middle text-truncate" style="max-width: 200px;">
                <code>{{ postback.url }}</code>
              </td>
              <td class="align-middle">{{ postback.createdAt | date: 'yyyy-MM-dd' }}</td>
              <td class="align-middle">{{ postback.updatedAt | date: 'yyyy-MM-dd' }}</td>
              <td class="align-middle">
                @if (postback.enabled) {
                  <i class="bi bi-check-circle-fill text-success"></i>
                }
                @if (!postback.enabled) {
                  <i class="bi bi-x-circle-fill text-danger"></i>
                }
              </td>
              <td class="align-middle">
                <button class="btn btn-sm btn-primary fw-bold">
                  <i class="bi bi-bar-chart-line"></i> Stats
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
